<template>
  <ContactUsModal ref="OpenContactUsModal" />
  <v-card color="transparent" class="card-jet" @click="OpenModal(jet)" elevation="7">
    <v-img :src="GetPathImage(jet.main_image_path)" :alt="jet.alt" class="card-image-jet" cover height="100%">
      <v-card-item class="px-3 pt-1 pt-sm-4 px-lg-4 pt-lg-5">
        <v-card-title class="fontSFProR card-jet-title">
          {{ jet.Manufacture }}
        </v-card-title>
        <v-row class="ma-0 row-tags mt-1">
          <v-col cols="auto" class="px-0 py-0 py-md-1">
            <div class="fontSFProR card-jet-text px-2 px-lg-3 py-1">
              {{ jet.Model }}
            </div>
          </v-col>
          <!-- <v-col cols="auto" class="px-0 py-0 py-md-1">
            <div class="fontSFProR card-jet-text px-2 px-lg-3 py-1">
              {{ jet['Rate per month'] }}€ / month
            </div>
          </v-col>
          <v-col cols="auto" class="px-0 py-0 py-md-1">
            <div class="fontSFProR card-jet-text px-2 px-lg-3 py-1">
              {{ jet['Rate per day'] }}€ / day
            </div>
          </v-col> -->
        </v-row>
      </v-card-item>


      <v-card-actions class="px-3 px-lg-4 pb-lg-4">
        <v-row>
          <v-col cols="12" :sm="min ? '8' : '6'" :md="min ? '7' : '5'">
            <v-btn @click="OpenModal(jet)" size="small" variant="flat" color="#DEE4EE" block
              class="card-btn px-3 fontSFProR">
              <template v-slot:prepend>
                <v-icon>
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.99898 4.22222C2.99898 3.10242 3.47312 2.02848 4.31709 1.23666C5.16106 0.44484 6.30573 0 7.49928 0C8.69284 0 9.83751 0.44484 10.6815 1.23666C11.5255 2.02848 11.9996 3.10242 11.9996 4.22222C11.9996 4.40886 11.9206 4.58785 11.7799 4.71982C11.6392 4.85179 11.4485 4.92593 11.2495 4.92593C11.0506 4.92593 10.8598 4.85179 10.7192 4.71982C10.5785 4.58785 10.4995 4.40886 10.4995 4.22222C10.4995 3.47569 10.1834 2.75973 9.62075 2.23185C9.0581 1.70397 8.29499 1.40741 7.49928 1.40741C6.70358 1.40741 5.94047 1.70397 5.37782 2.23185C4.81517 2.75973 4.49908 3.47569 4.49908 4.22222C4.49908 4.40886 4.42006 4.58785 4.27939 4.71982C4.13873 4.85179 3.94795 4.92593 3.74903 4.92593C3.5501 4.92593 3.35932 4.85179 3.21866 4.71982C3.078 4.58785 2.99898 4.40886 2.99898 4.22222ZM16.4277 9.14815C15.6205 9.18333 14.9998 9.83602 14.9998 10.5934V11.2338C15.0024 11.4154 14.9316 11.5912 14.8017 11.7258C14.6718 11.8604 14.4923 11.9439 14.2994 11.9594C14.1968 11.9658 14.0939 11.9524 13.9971 11.9199C13.9003 11.8874 13.8116 11.8366 13.7366 11.7706C13.6616 11.7046 13.6019 11.6248 13.5611 11.5363C13.5204 11.4477 13.4995 11.3522 13.4997 11.2557V9.18773C13.4997 8.43037 12.879 7.78032 12.0718 7.7425C11.869 7.73333 11.6663 7.76289 11.476 7.82939C11.2857 7.8959 11.1118 7.99795 10.9647 8.12938C10.8177 8.26081 10.7007 8.41887 10.6207 8.59399C10.5408 8.7691 10.4995 8.95763 10.4995 9.14815V10.5318C10.5021 10.7134 10.4313 10.8892 10.3014 11.0238C10.1714 11.1585 9.992 11.242 9.79913 11.2575C9.69653 11.2639 9.59363 11.2504 9.49681 11.2179C9.4 11.1854 9.31134 11.1346 9.23634 11.0686C9.16134 11.0026 9.1016 10.9229 9.06084 10.8343C9.02008 10.7457 8.99916 10.6503 8.99939 10.5538V4.26181C8.99939 3.50444 8.37872 2.8544 7.57148 2.81657C7.36865 2.80741 7.16595 2.83697 6.97566 2.90347C6.78537 2.96997 6.61145 3.07203 6.46444 3.20345C6.31743 3.33488 6.20039 3.49294 6.12042 3.66806C6.04045 3.84318 5.9992 4.03171 5.99918 4.22222V14.7549C6.00146 14.9251 5.93944 15.0905 5.82412 15.2219C5.70879 15.3533 5.54761 15.4421 5.36914 15.4727H5.35789C5.24601 15.4845 5.13291 15.4649 5.03282 15.4166C4.93273 15.3682 4.85011 15.2932 4.79535 15.2009L2.82647 11.9955C2.42331 11.3393 1.53825 11.0657 0.820079 11.4132C0.638603 11.4998 0.477814 11.6201 0.347505 11.7669C0.217195 11.9137 0.120094 12.0838 0.062114 12.2669C0.00413414 12.45 -0.0135106 12.6423 0.0102548 12.832C0.0340202 13.0217 0.0986982 13.2049 0.200349 13.3704L3.1068 18.6525C3.17259 18.7577 3.26637 18.845 3.37896 18.9059C3.49155 18.9668 3.61907 18.9993 3.74903 19H16.4999C16.6392 19.0001 16.7759 18.9638 16.8944 18.8951C17.013 18.8264 17.1088 18.7281 17.1712 18.6112C17.2049 18.5479 18 17.2865 18 15.0355V10.5556C18.0002 10.3649 17.9592 10.1762 17.8793 10.0008C17.7995 9.82552 17.6825 9.66725 17.5354 9.53563C17.3884 9.40402 17.2144 9.30181 17.024 9.2352C16.8335 9.16859 16.6307 9.13897 16.4277 9.14815Z"
                      fill="#343330" />
                  </svg>
                </v-icon>
              </template>
              {{ t(`$vuetify.cards.btn_book_it_now`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-img>
  </v-card>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "./Modals/ContactUsModal.vue";

export default {
  name: "CardJet",
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  props: {
    jet: Object,
    min: Boolean,
  },
  components: {
    ContactUsModal
  },
  methods: {
    OpenModal(jet) {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
    GetPathImage(image) {
      if (!image) return ""
      return require('@/assets/' + image)
    }
  },
};
</script>
<style scoped>
.card-jet-text {
  color: #FFFFFF;
  font-size: 0.8rem;
  border-radius: 20px;
  background: rgba(38, 38, 38, 0.6);
  backdrop-filter: blur(3px);
  text-transform: uppercase;
  font-weight: 600;
  width: fit-content;
  letter-spacing: 0px;
  box-shadow: 15px 4px 35px 0px rgba(0, 0, 0, 0.70);
}

.card-jet-title {
  color: #FFFFFF;
  transition: .7s;
  font-size: 1.7rem;
  text-shadow: 5px 3px 7px rgba(0, 0, 0, 0.70);
}

.card-btn {
  justify-content: space-between;
  border-radius: 15px;
  box-shadow: unset;
  font-weight: 500;
  font-size: 1rem;
  text-transform: inherit;
  letter-spacing: 0.5px;
}

.card-jet {
  height: 100%;
  border-radius: 15px;
  cursor: pointer;
  min-height: 320px;
}

.row-tags {
  column-gap: 5px;
}

@media screen and (max-width: 600px) {
  .card-btn {
    font-size: .8rem;
  }

  .card-jet-text {
    font-size: 0.5rem;
  }

  .card-jet-title {
    font-size: 1.4rem;
  }

  .row-tags {
    column-gap: 4px;
    row-gap: 4px;
  }
}

@media screen and (min-width: 600px) and (max-width: 960px) {
  .card-btn {
    font-size: .8rem;
  }

  .card-jet-text {
    font-size: 0.55rem;
  }

  .row-tags {
    column-gap: 4px;
    row-gap: 4px;
  }

  .card-jet-title {
    font-size: 1.4rem;
  }

}

@media screen and (min-width: 960px) and (max-width: 1200px) {

  .card-jet-text {
    font-size: 0.6rem;
  }

}
</style>

<style>
.card-image-jet .v-card-item__content {
  overflow: visible;
}

.card-image-jet .v-responsive__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.card-jet:hover .card-jet-title {
  filter: invert(1);
  text-shadow: unset;
}

.card-jet:hover .v-responsive__sizer {
  opacity: 0.1;
}

.card-image-jet .v-img__img--cover,
.card-jet .v-responsive__sizer {
  transition: .7s;
}

.card-jet:hover .card-image-jet .v-img__img--cover {
  scale: 1.1;
}

.card-image-jet .v-responsive__sizer {
  background: linear-gradient(180deg, rgba(10, 10, 10, 0.25) 46.06%, rgba(20, 20, 20, 0.40) 112.49%);
}
</style>